// src/helper/noScheduleNoChecks.js
import isEmptyTime from './isEmptyTime';

/*
 * Повертає true, якщо немає розкладу і відміток приходу/виходу.
 * @param {{schedule_in?:string, schedule_out?:string, check_in?:string, check_out?:string}} [item={}]
 * @returns {boolean}
 */
export default function noScheduleNoChecks(item = {}) {
	return (
		!item.isDisabled &&
		!item.vacation &&
		!item.sick &&
		!item.holiday &&
			isEmptyTime(item.schedule_in) &&
			isEmptyTime(item.schedule_out) &&
			isEmptyTime(item.check_in) &&
			isEmptyTime(item.check_out)
	);
}
